import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingOverlay from './components/LoadingOverlay';

export default function RootRedirect() {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/check_login`, {
          method: 'GET',
          credentials: 'include'
        });
        const result = await response.json();

        if (result.result === 'success') {
          switch (result.userType) {
            case 'aspUser':
              setTarget('/aspirant');
              break;
            case 'orgUser':
              setTarget('/organization');
              break;
            case 'adminUser':
              setTarget('/admin/dashboard');
              break;
            default:
              window.location.replace(process.env.REACT_APP_MARKETING_URL);
              break;
          }
        } else {
          window.location.replace(process.env.REACT_APP_MARKETING_URL);
        }
      } catch {
        window.location.replace(process.env.REACT_APP_MARKETING_URL);
      }
    };

    checkLogin();
  }, []);

  if (target) {
    return <Navigate to={target} replace />;
  }

  return <LoadingOverlay loading={true} />;
}
